import { axiosInstance } from '../common/api';

export const activateAccountService = (token) => {
  const url = `/auth/confirmation/${token}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
